/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleToolbarAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Hide from './Hide/index'
import React from 'react'
import Show from './Show/index'



/** @type {import('Simple/types.js').View} */
export default function ToggleToolbarAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Gallery/Content/ToggleToolbarAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Hide'
let galleryIsToolbarHiddenValueData = fromData.useDataFormat({ viewPath,
context: 'gallery',
path: 'is_toolbar_hidden',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: galleryIsToolbarHiddenValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Hide'}>
<Hide
  viewPath={`${viewPath}/Hide`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Show'}>
<Show
  viewPath={`${viewPath}/Show`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}